import React from 'react'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/images'
import './Config.css'

const Config = () => {
  const { t } = useTranslation()
  const steps = t('academyConfig.steps', { returnObjects: true }) || []

  return (
    <section className='academy-config' id='how-it-works'>
      <div className='academy-config-content'>
        <div className='academy-config-top'>
          <div className='academy-config-copy'>
            <h2>
              {t('academyConfig.title')}
              <span>{t('academyConfig.titleHighlight')}</span>
            </h2>

            <p>{t('academyConfig.description')}</p>

            <button
              type='button'
              className='academy-config-cta'
              onClick={() => window.location.href = 'mailto:hello@tiimapp.com'}
            >
              {t('academyConfig.button')}
            </button>
          </div>

          <div className='academy-config-image-wrap'>
            <img src={Images.academy.config} alt='academy config' className='academy-config-image' />
          </div>
        </div>

        <div className='academy-config-steps'>
          {steps.map((step, index) => (
            <article key={index} className='academy-config-step'>
              <span className='step-number'>{index + 1}</span>
              <div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Config
